/* eslint-disable camelcase */
import { AxiosResponse } from 'axios'
import api from 'Services/api'

import { Grupo } from '../../../hooks/grupo/useGrupos/types'
import { GrupoApi } from './types'

const GRUPO_PRODUTO_BASE_URL = '/cadastro/grupo'

const grupoApiService = {
  create(data: Partial<Grupo>): Promise<AxiosResponse<GrupoApi>> {
    return api.post(`${GRUPO_PRODUTO_BASE_URL}/`, data)
  },
  deleteById(idgrupo: string): Promise<AxiosResponse<void>> {
    return api.delete(`${GRUPO_PRODUTO_BASE_URL}/${idgrupo}/`)
  },
  getById(idgrupo: string): Promise<AxiosResponse<GrupoApi>> {
    return api.get(`${GRUPO_PRODUTO_BASE_URL}/${idgrupo}/`)
  },
  list(filtros: any = {}): Promise<AxiosResponse<GrupoApi[]>> {
    return api.get('/api/grupo/', { params: filtros })
  },
  updateById(idgrupo: string, data: Partial<Grupo>): Promise<AxiosResponse<GrupoApi>> {
    return api.put(`${GRUPO_PRODUTO_BASE_URL}/${idgrupo}/`, data)
  },

  bulkUpdate(payload: any): Promise<AxiosResponse<any>> {
    return api.post(`${GRUPO_PRODUTO_BASE_URL}/bulk_update/`, payload)
  }
}

export default grupoApiService
